import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { MontoCompra } from '../../cliente/montoCompra.model';
import { TipoMoneda } from '../../cliente/tipoMoneda.model';
import { ApiService } from '../../core/api.service';
import { Cliente } from '../../cliente/cliente.model';

@Component({
  selector: 'app-complete-monto-compra',
  templateUrl: './complete-monto-compra.component.html',
  styleUrls: ['./complete-monto-compra.component.scss']
})
export class CompleteMontoCompraComponent implements OnInit {

  @Input() clienteId: number;
  @Input() montoCompra: MontoCompra;
  @Output() onAddMontoCompra = new EventEmitter<boolean>();
  operationalMontoCompra = { monto: 0, tipoMoneda : {id: 2}};
  private staticMontoCompra = { monto: 0, tipoMoneda : {simbolo: ''}};
  ultimosMontos: MontoCompra[];

  tiposMonedas: TipoMoneda[];

  isLoading: true;

  constructor(
    private backendService: BackendService,
    private apiService: ApiService,
    private snackService: SnackService
  ) { }

  hasMontoCompra() {
    if (this.staticMontoCompra.tipoMoneda.simbolo !== '') {
      return true;
    }
    return false;
  }

  async getTiposMonedas() {
    this.tiposMonedas = await this.apiService.get(TipoMoneda, TipoMoneda.path, null).toPromise();
  }

  async save() {

    this.snackService.spinner(true);
    try {
      await this.backendService.create(Cliente.path + MontoCompra.path + this.clienteId, this.operationalMontoCompra);
      this.snackService.success('Monto límite de compra actualizado');
      this.updateView();
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);
    }
  }

  updateView() {
    for (const tipoMoneda of this.tiposMonedas) {
      if (this.operationalMontoCompra.tipoMoneda.id === tipoMoneda.id) {
        this.staticMontoCompra.tipoMoneda.simbolo = tipoMoneda.simbolo;
      }
    }
    this.staticMontoCompra.monto = this.operationalMontoCompra.monto;
    this.onAddMontoCompra.emit(true);
    this.getUltimosMontos(5);
  }
  ngOnInit() {
    this.getTiposMonedas();
    if (this.montoCompra) {
      this.operationalMontoCompra = this.montoCompra;
      this.staticMontoCompra.monto = this.montoCompra.monto;
      this.staticMontoCompra.tipoMoneda.simbolo = this.montoCompra.tipoMoneda.simbolo;
    }
    this.getUltimosMontos(5);
  }

  async getUltimosMontos(cant) {
    const path = '/clientes/ultimos_montos_compra/' + this.clienteId + '?cant=' + cant;
    await this.backendService.getUltimosMontos(path).then(res => {
      this.ultimosMontos = res as MontoCompra[];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/complete-monto-compra/complete-monto-compra.component.ts